<template>
    <DnPaginator class="base-paginator palette--mma">
        <template
            v-for="name in Object.keys($slots)"
            v-slot:[name]="scope"
        >
            <slot
                :name="name"
                v-bind="scope"
            />
        </template>
        <template #previous="{ goToPreviousPage, isDisabled }">
            <BaseButton v-show="!isDisabled" icon="marker:chevron_left" class="base-paginator__button" transparent @click="goToPreviousPage" />
        </template>
        <template #pageNumber="{ pageNumber, goToPage, isActive }">
            <BaseButton :secondary="!isActive" :label="pageNumber?.toString()" class="base-paginator__button" @click="goToPage(pageNumber)" />
        </template>
        <template #next="{ goToNextPage, isDisabled }">
            <BaseButton v-show="!isDisabled" icon="marker:chevron_right" class="base-paginator__button" transparent @click="goToNextPage" />
        </template>
    </DnPaginator>
</template>

<script setup>
import DnPaginator from '@digitalnatives/paginator';
</script>

<style src="./BasePaginator.less" lang="less" />
